import React from "react";
import { connect } from "react-redux";
import { setDataNewComplain, setCiudadesComunas, setCiudadesComunasSiniestro } from "../../actions";
import { SetLatitudeLongitude, GetDirectionsMetadata } from "../../../../../../Maps/actions";
import SelectField from "../../../../../../Shared/fields/SelectField";
import TextField from "../../../../../../Shared/fields/TextField";
import { getRegiones, getCiudadesComunas } from "../../../../../../../helpers/direccionesNuevaDenunciaFormat";
import { setRegionesList } from "../../../../../../Global/actions";

class DirectionFields extends React.Component {
  componentDidMount = () => {
    if (this.props.listaRegiones.length === 0) {
      this.props.dispatch(setRegionesList(getRegiones(this.props.listaDirecciones)));
    }

    switch (this.props.activeStep) {
      case 2: {
        if ((this.props.jsonData.formInfoTrabajador.lat && this.props.jsonData.formInfoTrabajador.lat !== null) && (this.props.jsonData.formInfoTrabajador.lng && this.props.jsonData.formInfoTrabajador.lng !== null)) {
          this.props.dispatch(SetLatitudeLongitude(this.props.jsonData.formInfoTrabajador.lat, this.props.jsonData.formInfoTrabajador.lng));
          this.setResultSearchMaps(this.props.jsonData.formInfoTrabajador);
        }
        if (this.props.jsonData.formInfoTrabajador.Region && this.props.jsonData.formInfoTrabajador.Region.IdRegion) {
          const result = getCiudadesComunas(this.props.listaDirecciones, this.props.jsonData.formInfoTrabajador.Region.IdRegion);
          this.props.dispatch(setCiudadesComunas(result.listaCiudades, result.listaComunas));
        }
        break;
      }
      case 3: {
        if ((this.props.jsonData.formDatoSiniestro.lat && this.props.jsonData.formDatoSiniestro.lat !== null) && (this.props.jsonData.formDatoSiniestro.lng && this.props.jsonData.formDatoSiniestro.lng !== null)) {
          this.props.dispatch(SetLatitudeLongitude(this.props.jsonData.formDatoSiniestro.lat, this.props.jsonData.formDatoSiniestro.lng));
          this.setResultSearchMaps(this.props.jsonData.formDatoSiniestro);
        }
        if (this.props.jsonData.formDatoSiniestro.Region && this.props.jsonData.formDatoSiniestro.Region.IdRegion) {
          const result = getCiudadesComunas(this.props.listaDirecciones, this.props.jsonData.formDatoSiniestro.Region.IdRegion);
          this.props.dispatch(setCiudadesComunasSiniestro(result.listaCiudades, result.listaComunas));
        }
        break;
      }
      default:
        break;
    }
  }


  onMapCreated(map) {
    map.setOptions({
      disableDefaultUI: true,
    });
  }
  setResultSearchMaps = (Data) => {
    const result = {};
    result.region = Data.Region;
    result.province = Data.Ciudad;
    result.commune = Data.Comuna;
    result.street = Data.Calle;
    result.number = Data.Numero;
    result.typeStreet = Data.TipoCalle;
    result.town = typeof Data.Poblacion === "undefined" ? "" : Data.Poblacion;

    this.props.dispatch(GetDirectionsMetadata(result));
  }
  setAdressByMaps = (result, lat, lng) => {
    const jsonData = { ...this.props.jsonData };

    switch (this.props.activeStep) {
      case 2: {
        jsonData.formInfoTrabajador.Region = result.region;
        jsonData.formInfoTrabajador.Comuna = result.commune;
        jsonData.formInfoTrabajador.Calle = result.street;
        jsonData.formInfoTrabajador.Numero = result.number;
        jsonData.formInfoTrabajador.Ciudad = result.province;
        jsonData.formDatoSiniestro.Poblacion = result.town;
        jsonData.formDatoSiniestro.TipoCalle = result.typeStreet;
        jsonData.formInfoTrabajador.lat = lat;
        jsonData.formInfoTrabajador.lng = lng;

        this.props.dispatch(setDataNewComplain(jsonData));
        break;
      }
      case 3: {
        jsonData.formDatoSiniestro.Region = result.region;
        jsonData.formDatoSiniestro.Comuna = result.commune;
        jsonData.formDatoSiniestro.Calle = result.street;
        jsonData.formDatoSiniestro.Numero = result.number;
        jsonData.formDatoSiniestro.Ciudad = result.province;
        jsonData.formDatoSiniestro.Poblacion = result.town;
        jsonData.formDatoSiniestro.TipoCalle = result.typeStreet;
        jsonData.formDatoSiniestro.lat = lat;
        jsonData.formDatoSiniestro.lng = lng;

        this.props.dispatch(setDataNewComplain(jsonData));
        break;
      }
      default:
        break;
    }
  }
  handleChange = (e) => {
    this.props.onChange(e);
  }
  render() {
    return (
      <React.Fragment>
        <SelectField
          label="Región"
          id="Region"
          required
          value={this.props.form.Region}
          dataSource={this.props.listaRegiones}
          displayExpr="DescripcionRegion"
          onChange={this.handleChange}
          acceptCustomValue
        />

        <TextField
          label="Ciudad"
          id="Ciudad"
          required
          value={this.props.form.Ciudad}
          disabled={!(this.props.form && this.props.form.Region && this.props.form.Region.IdRegion)}
          onChange={this.handleChange}
        />

        <SelectField
          label="Comuna"
          id="Comuna"
          required
          searchExpr={["DescripcionCommuna"]}
          searchEnabled
          value={this.props.form.Comuna}
          dataSource={this.props.listaComunas}
          displayExpr="DescripcionCommuna"
          disabled={!(this.props.form && this.props.form.Region && this.props.form.Region.IdRegion)}
          onChange={this.handleChange}
          acceptCustomValue
        />


        {this.props.renderPhone &&
          <div className="row zero-vertical">
            <div className="col-1" style={{ color: "#787878", marginTop: 54 }}> +56 </div>
            <div className="col-4 zero-right">
              <SelectField
                id="Code"
                label="Código de área"
                searchEnabled
                value={this.props.form.Code}
                disabled={!this.props.form.Comuna}
                onValueChanged={this.handleChange}
                items={this.props.listaCodigoArea}
                acceptCustomValue
                validation={false}
              />

            </div>
            <div className="col-7">
              <TextField
                label="Teléfono"
                maxLength={8}
                id="Phone"
                skipValidation
                mask={this.props.form.Code && this.props.form.Code.indexOf("+") !== -1 ? "0000 0000" : null}
                value={this.props.form.Phone}
                onValueChanged={this.handleChange}
              />

            </div>
          </div>}

        <SelectField
          label="Tipo de calle"
          id="TipoCalle"
          required
          value={this.props.form.TipoCalle}
          dataSource={this.props.listaTipoCalle}
          displayExpr="TipoCalle"
          onChange={this.handleChange}
          acceptCustomValue
        />

        <TextField
          id="Calle"
          label="Calle"
          required
          maxLength={60}
          value={this.props.form.Calle}
          disabled={this.props.form.TipoDireccion === "Google Maps" && this.props.directionMetadata.street !== ""}
          onValueChanged={this.handleChange}

        />
        <TextField
          id="Numero"
          label="Número"
          required
          maxLength={10}
          value={this.props.form.Numero}
          disabled={this.props.form.TipoDireccion === "Google Maps" && this.props.directionMetadata.number !== ""}
          onValueChanged={this.handleChange}

        />
        <TextField
          id="Poblacion"
          label="Población o villa"
          skipValidation
          maxLength={40}
          value={this.props.form.Poblacion}
          disabled={this.props.form.TipoDireccion === "Google Maps" && this.props.directionMetadata.town !== ""}
          onValueChanged={this.handleChange}

        />

      </React.Fragment>

    );
  }
}

const mapStateToProps = (state) => ({
  jsonData: state.denuncias.jsonData,
  activeStep: state.denuncias.activeStep,
  params: state.map.params,
  center: state.map.center,
  zoom: state.map.zoom,
  directionMetadata: state.map.directionMetadata,
  listaDirecciones: state.global.listaDirecciones,
  listaRegiones: state.global.listaRegion,
  listaComunas: state.denuncias.activeStep === 2 ? state.denuncias.listaComunas : state.denuncias.listaComunasSiniestro,
  listaCiudades: state.denuncias.activeStep === 2 ? state.denuncias.listaCiudades : state.denuncias.listaCiudadesSiniestro,
  listaCodigoArea: state.denuncias.listaCodigoAreaAll,
  listaTipoCalle: state.global.listaTiposCalle,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(DirectionFields);

